<template>
  <div class="page-view-log">
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目操作日志</span>
      </div>
      <div class="list-table-container">
        <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="loading" :data-source="list" :scroll="{ x: '100%' }" rowKey="opId">
          <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
            <template slot-scope="text, record, index">{{ index + 1 }}</template>
          </a-table-column>
          <a-table-column title="操作" data-index="opType" align="left">
            <template slot-scope="text, record">
              {{ record.opType }}
              <template v-if="record.opTypeCode && record.opTypeCode.endsWith('REVIEW')">
                <a-tag color="#3f51b5" class="tag-tiny" v-if="record.opStatus === 1">通过</a-tag>
                <a-tag color="#ee1100" class="tag-tiny" v-else-if="record.opStatus === 0">驳回</a-tag>
              </template>
            </template>
          </a-table-column>
          <a-table-column title="操作用户" data-index="opUser" align="left" />
          <a-table-column title="操作IP" :width="200" data-index="opIp" align="left" />
          <a-table-column title="操作时间" :width="200" data-index="opTime" align="center" />
        </a-table>
        <div class="list-toolbar flex items-center">
          <div class="list-toolbar-extra">
            共
            <span class="text-primary font-special">{{ pagination.total }}</span>
            条记录
          </div>
          <div class="list-pagination v-ml-auto">
            <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listLog } from '@/api/system/log'
export default {
  data() {
    return {
      id: +this.$route.query.id,
      loading: false,
      list: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  methods: {
    load(page = 1, pageSize = 10) {
      this.loading = true
      let params = {
        bizs: ['PROJECT_OTHER', 'PROJECT'],
        bizId: this.id,
        page,
        pageSize,
      }
      listLog(params)
        .then(({ data }) => {
          if (data.success) {
            let { current, size, total, records } = data.result
            this.list = records
            this.pagination = {
              page: current,
              pageSize: size,
              total,
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onPageChange(page, pageSize) {
      this.load(page, pageSize)
    },
  },
  mounted() {
    this.load()
  },
}
</script>
